var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('h3',[_vm._v("Welcome to the SoftPro Atmos portal!")]),_c('p',[_vm._v("This portal is the primary location for the management of your SoftPro software.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }